import FJConfig from '../../../config/FJConfig';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJNotSupportBrowser.module.less';
import GoogleIcon from '../../../assets/svg/chrome.svg?react';

const FJNotSupportBrowser = () => {
    const handleDownloadChrome = () => {
        window.open('https://www.google.com/chrome/', '_blank');
    };
    return (
        <div className={styles.container}>
            <img src={FJConfig.notSupportBrowserImage} alt='not-support-browser' />
            <div className={styles.title}>{FJLocalStore._('please-use-google-chrome-to-try-again')}</div>
            <div className={styles.description}>{FJLocalStore._('please-use-google-chrome-to-try-again-desc')}</div>
            <div className={styles.button} onClick={handleDownloadChrome}>
                <GoogleIcon />
                <div className={styles.buttonText}>{FJLocalStore._('download-google-chrome')}</div>
            </div>
        </div>
    );
};

export default FJNotSupportBrowser;
